export { default as AspectRatio } from './AspectRatio';
export type { AspectRatioProps } from './types';
